import PropTypes from 'prop-types';

import { Col, Space, Tag, Typography } from 'antd';

import { getAddressFromEntityAddress, getColor } from '../../clientUtils';
import { FACILITY_TYPES } from '../../constants';

const { Text } = Typography;

const Address = ({ entity, className, offset = 0, showType = false }) => {
  const addressType = entity?.address_type || entity?.addressType;
  const facilityCode = entity?.facility?.facility_code || entity?.facility_code;
  const wms = entity?.facility?.wms || entity?.wms;
  const gstNumber = entity?.gst_number || entity?.gstNumber;

  return (
    <Col className={`w-300px ${className}`} offset={offset}>
      <Space direction="vertical">
        <Text>{getAddressFromEntityAddress(entity, false)}</Text>
        {!!gstNumber && (
          <Space>
            <Text>GSTIN</Text>
            <Text strong>{gstNumber}</Text>
          </Space>
        )}
        {!!wms && (
          <Space>
            <Text>WMS</Text>
            <Text strong>
              {wms} - {facilityCode}
            </Text>
          </Space>
        )}
        {!!showType && !!addressType && (
          <Tag className="br-20 fw-500" color={getColor(addressType)} style={{ marginRight: 0, fontSize: 11 }}>
            {FACILITY_TYPES?.[addressType]}
          </Tag>
        )}
      </Space>
    </Col>
  );
};

Address.defaultProps = {
  entity: {},
  className: '',
  offset: 0,
  showType: false
};

Address.propTypes = {
  entity: PropTypes.shape({
    address_type: PropTypes.string,
    addressType: PropTypes.string,
    facility_code: PropTypes.string,
    facilityCode: PropTypes.string,
    gst_number: PropTypes.string,
    gstNumber: PropTypes.string,
    wms: PropTypes.string
  }),
  className: PropTypes.string,
  offset: PropTypes.number,
  showType: PropTypes.bool
};

export default Address;
